import { registerStep } from "./stepsRegistry";
import type { StepDefinition } from "./types";
import { GeneralidadesStep } from "@/components/form-steps/GeneralidadesStep";
import { GeneralidadesSchema } from "@/schemas/multistep/generalidades.schema";

const definition: StepDefinition = {
  id: "generalidades",
  title: "Generalidades",
  schema: GeneralidadesSchema,
  Component: GeneralidadesStep,
  isApplicable: () => true,
};

registerStep(definition);
